// ─────────────────────────────────────────────────────────────────────────────
// Root.jsx
//
// Top-level routing. The Fractals project has two products in one codebase:
//
//   /          → Toolkit (App.js) — the creation tool for artists
//   /player    → Ambient Player — the curated library for studios
//
// We use a minimal pathname check rather than react-router because the entire
// routing logic is one branch and adding a router would be over-engineering.
// If a third product ever joins, switch to react-router at that point.
//
// Both routes share the same Firebase Auth and Firestore (via userTier.js).
// Sign-in lives in the Toolkit's header for now; the Player surfaces who
// is signed in but defers sign-in to the Toolkit. Studios will normally
// only see the Player, so they'll sign in by clicking "Sign in via Toolkit"
// once at setup time.
// ─────────────────────────────────────────────────────────────────────────────

import React from "react";
import App from "./App";
import Player from "./Player";

export default function Root() {
  const path = typeof window !== "undefined" ? window.location.pathname : "/";

  if (path === "/player" || path.startsWith("/player/")) {
    return <Player />;
  }

  return <App />;
}
